module.exports = __webpack_public_path__ + "media/images/front/medical_leaders/top/img_result14-30c1af10a2697a2417c81473d2e246da.png";